<!-- 
A card from the notice timeline.
-->
<template>
  <v-timeline-item
    :key="`parent-${index}`"
    :color="getColour(notice)"
    :icon="getIcon(notice)"
    :large="!dense"
    name="`parent-${index}`"
    class="pb-4"
    fill-dot
  >
    <v-card :color="getColour(notice)" dark>
      <v-card-title class="pl-3 pt-2 pr-2 pb-2 subheading" style="min-height:52px;">
        {{ description }}
      </v-card-title>
      <v-card-text class="white text--primary pr-2">
        <v-layout row wrap>
          <v-flex xs12 md9>
            <span class="font-weight-medium">Sent {{ notice.date | friendlyDateTime }}</span>
            <p v-for="item in getRecipients(notice.to)" :key="item" class="caption mb-0">{{ item }}</p>
          </v-flex>
          <v-flex xs12 md3 text-xs-right>
            <v-btn
              class="mx-0"
              color="primary"
              flat
              @click="show(notice)"
            >
              View
            </v-btn>
          </v-flex>
        </v-layout>
        <template v-for="childNotice of notice.resends">
          <v-layout :key="`resent-layout-${childNotice.id}`" mt-2 row wrap>
            <v-flex xs12 md9>
              <span class="font-weight-medium">Resent {{ childNotice.date | friendlyDateTime }}</span>
              <p v-for="item in getRecipients(childNotice.to)" :key="item" class="caption mb-0">{{ item }}</p>
            </v-flex>
            <v-flex xs12 md3 text-xs-right>
              <v-btn
                class="mx-0"
                color="primary"
                flat
                @click="show(childNotice)"
              >
                View
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
      </v-card-text>
      <v-card-actions v-if="hasResendableNotice(notice)" style="background-color: white;">
        <v-spacer/>
        <v-btn class="mx-0" flat color="primary" @click="resend(notice)">Resend</v-btn>
      </v-card-actions>
    </v-card>
  </v-timeline-item>
</template>

<script>
import _ from "underscore";
import filterMixins from "@/mixins/filter.mixins";
import { NOTICES_RESEND } from "@/store/claim-types";

export default {
  mixins: [filterMixins],
  props: {
    notice: {
      type: Object,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    colour() {
      const t = this.notice.type;
      return t == "PaymentOverdueWarningNotice" || t == "PaymentDueReminderNotice" ? "error" : "primary";
    },
    hasResendPermission() {
      return this.$store.getters.claims.includes(NOTICES_RESEND);
    }
  },
  methods: {
    getRecipients(values) {
      return values ? values.split(/[\s,;]+/) : null;
    },
    show(notice) {
      this.$emit("show", notice);
    },
    resend(notice) {
      this.$emit("resend", this.getResendableNotice(notice));
    },
    getIcon(notice) {
      switch (notice.type) {
        case "InvoiceNotice":
          return "attach_money";
        case "PaymentDueReminderNotice":
        case "PaymentOverdueWarningNotice":
          return "schedule";
        case "LatePaymentNotice":
          return "announcement";
        default:
          return "speaker_notes";
      }
    },
    getColour(notice) {
      const t = notice.type;
      if (t == "PaymentDueReminderNotice" || t == "PaymentOverdueWarningNotice" || t == "LatePaymentNotice") {
        return "red darken-3";
      }
      if (t == "InvoiceNotice") {
        return "orange darken-1";
      }
      return "cyan darken-3";
    },
    getResendableNotice(parentNotice) {
      if (!this.hasResendPermission) {
        return null;
      }
      if (parentNotice.canResend) {
        return parentNotice;
      }
      const resendableNotice = _(parentNotice.resends).find(n => n.canResend);
      return resendableNotice ? resendableNotice : null;
    },
    hasResendableNotice(parentNotice) {
      return !!this.getResendableNotice(parentNotice);
    }
  }
};
</script>

<style lang="scss" scoped>
.theme--light.v-timeline:before {
  background-color: #7a7a7a !important;
  width: 3px;
}
.expanding-header {
  cursor: pointer;
}
.expanding-header:hover {
  color: var(--v-primary-base);
}
.focus-box {
  padding: 1px;
}
</style>